(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('om-verified-color-results')) {
  customElements.define('om-verified-color-results', class extends HTMLElement {
    connectedCallback() {
      const generation = (this.generation || 0) + 1;
      this.generation = generation;
      const controller = new AbortController();
      this.controller = controller;
      const timer = setTimeout(() => controller.abort(), 45000);
      this.timer = timer;
      Promise.resolve().then(() => this.run(controller, generation)).catch(() => {
        controller.abort();
        if (!this.isConnected || this.generation !== generation) return;
        this.querySelector('product-list').replaceChildren();
        this.querySelector('product-list').hidden = true;
        this.querySelector('[data-om-status]').textContent = this.dataset.errorLabel;
      }).finally(() => clearTimeout(timer));
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
    async run(controller, generation) {
      const pages = Number(this.dataset.pages), current = Number(this.dataset.page);
      if (!Number.isSafeInteger(pages) || pages < 1 || pages > 30) throw new Error('Unbounded result');
      const url = new URL(location.href), signature = this.dataset.signature;
      const results = new Map();
      const read = (root, page) => {
        if (!root || root.dataset.signature !== signature || root.dataset.theme !== this.dataset.theme || Number(root.dataset.pages) !== pages || Number(root.dataset.page) !== page) throw new Error('Source changed');
        results.set(page, [...root.querySelectorAll('product-card[data-om-product-id][data-om-variant-id]')].map(card => card.cloneNode(true)));
      };
      read(this, current);
      let next = 1;
      const worker = async () => {
        while (next <= pages) {
          const page = next++;
          if (page === current) continue;
          const request = new URL(url);
          request.searchParams.set('page', String(page));
          request.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(request, {signal:controller.signal, credentials:'same-origin', cache:'no-store'});
          if (!response.ok) throw new Error('Page failed');
          const html = await response.text();
          if (html.length > 2500000) throw new Error('Oversized page');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          read(doc.querySelector('om-verified-color-results'), page);
        }
      };
      await Promise.all(Array.from({length:Math.min(3,pages)}, worker));
      if (!this.isConnected || controller.signal.aborted || this.generation !== generation || location.href !== url.href || results.size !== pages) throw new Error('Incomplete');
      const seen = new Set(), cards = [];
      for (let page=1; page<=pages; page++) for (const card of results.get(page)) {
        const id = card.dataset.omProductId;
        if (!id || seen.has(id)) continue;
        seen.add(id); card.removeAttribute('reveal-on-scroll'); cards.push(card);
      }
      if (this.dataset.sort === 'price-ascending' || this.dataset.sort === 'price-descending') {
        const direction = this.dataset.sort === 'price-ascending' ? 1 : -1;
        if (cards.some(c => !Number.isFinite(Number(c.dataset.omPrice)))) throw new Error('Price missing');
        cards.sort((a,b) => direction*(Number(a.dataset.omPrice)-Number(b.dataset.omPrice)));
      }
      this.cards = cards; this.shown = 0;
      const grid = this.querySelector('product-list'); grid.replaceChildren(); grid.hidden = false;
      this.querySelector('[data-om-more]').addEventListener('click', () => this.more());
      this.more();
    }
    more() {
      const end = Math.min(this.shown + 24, this.cards.length);
      this.querySelector('product-list').append(...this.cards.slice(this.shown,end));
      this.shown = end;
      this.querySelector('[data-om-more]').hidden = end >= this.cards.length;
      this.querySelector('[data-om-status]').textContent = this.dataset.countLabel.replace('{count}',String(this.cards.length)).replace('{shown}',String(end));
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
